import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ckw7fxand: FaireProductEntity = {
  token: "p_3ckw7fxand",
  type: "product",
  name: "Brazil - Mundo Novo (Single Origin) 12oz Whole Bean",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/ba8580fe9a56a3952df4e9dd60e6e3c971f4dfff919bd6235dc6c3b06d786c9a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf1a04fda53ca938297f5ea2fafc37b91870818155e1adbbeee7c0811907ffa0.jpeg",
    "https://cdn.faire.com/fastly/d9f1b8f3235684c9fa4d1330afe6d2a92aa6e68180f0f11ca9229808291d9f6a.jpeg",
    "https://cdn.faire.com/fastly/25ff161bc2c5e66451e45e2998ccbd1694549d9077b69e559956ae2325ae8774.jpeg"
  ],
  priceDollars: 15.66,
  description: "Our friends at Los Volcanes return to our menu with another lovely Brazilian coffee produced in collaboration with Fazenda Rio Brilhante. This lot is a single-variety selection of Mundo Novo, offering a beautiful representation of a more classic Brazilian flavor profile.\n\nThis is an excellent choice for both filter coffee and espresso, enjoyed with milk or without. Expect a full-bodied coffee with comforting notes of milk chocolate, hazelnut, almond, caramel, pear, and raspberry.\n\nCoffee Info:\nProducers: Urban Family & Los Volcanes Coffee\nTasting Notes:  Milk Chocolate, Caramel, and Raspberry\nElevation: 900-1,150 meters \nRegion: Pântano, Cerrado Mineiro, Minas Gerais\nVariety: Mundo Novo\nProcess:  Natural\n\nFarm Relationship?\nYes—4 years!",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:32.657Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
